import React from 'react'
import { CobuStack, CobuBackButton } from '@cobu/ui'

export const HEADER_MAX_HEIGHT = 200
export const HEADER_MIN_HEIGHT = 40

type PublicProfileCollapsingHeaderProps = {
  user: any
  currentUser: any
  scrollY?: number
  onBackPress: () => void
  onMessage?: () => void
  onMoreOptions?: () => void
  onProfileImagePress?: () => void
}

export default function PublicProfileCollapsingHeader({
  scrollY = 0,
  onBackPress,
}: PublicProfileCollapsingHeaderProps) {
  const clampedScroll = Math.max(0, scrollY)
  const rawHeight = HEADER_MAX_HEIGHT - clampedScroll
  const headerHeight = Math.max(HEADER_MIN_HEIGHT, rawHeight)

  return (
    <div style={{ position: 'relative', zIndex: 10 }}>
      {/* Collapsing Blue Background Space */}
      <CobuStack
        h={headerHeight as any}
        bg="$cobuTeal"
        style={{
          transition: 'height 150ms ease-out',
          zIndex: 1,
        }}
      />
      <CobuStack
        layout="horizontal"
        ai="center"
        jc="space-between"
        px="$4"
        py="$3"
        color="$white"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 20,
        }}
      >
        <CobuBackButton onPress={onBackPress} />
      </CobuStack>
    </div>
  )
}

